import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import ENTRY_STATUS from '../../../constants/entry-status';

// NOTE: ダウンロード済の場合は、非表示
const Main = ({ status }) => (status && status === ENTRY_STATUS.CODE.DOWNLOADED) ? null : (
  <div className="steps">
    <div className={`step-item is-info ${!status ? 'is-active' : 'is-completed'}`}>
      <div className="step-marker">
        <span className="icon">
          <FontAwesomeIcon icon={faCheck}/>
        </span>
      </div>
      <div className="step-details">
        <p className="step-title is-size-6 is-size-7-mobile">お申し込み</p>
      </div>
    </div>
    <div className={`step-item is-info ${[ENTRY_STATUS.CODE.ORDERED, ENTRY_STATUS.CODE.SHIPPED].includes(status) ? 'is-active' : ''} ${[ENTRY_STATUS.CODE.REGISTERED, ENTRY_STATUS.CODE.DOWNLOAD_AVAILABLE].includes(status) ? 'is-completed' : ''}`}>
      <div className="step-marker">
        <span className="icon">
          <FontAwesomeIcon icon={faCheck}/>
        </span>
      </div>
      <div className="step-details">
        <p className="step-title is-size-6 is-size-7-mobile">キットの受け取り</p>
      </div>
    </div>
    <div className={`step-item is-info ${[ENTRY_STATUS.CODE.SHIPPED].includes(status) ? 'is-active' : ''} ${[ENTRY_STATUS.CODE.REGISTERED, ENTRY_STATUS.CODE.DOWNLOAD_AVAILABLE].includes(status) ? 'is-completed' : ''}`}>
      <div className="step-marker">
        <span className="icon">
          <FontAwesomeIcon icon={faCheck}/>
        </span>
      </div>
      <div className="step-details">
        <p className="step-title is-size-6 is-size-7-mobile">登記所に申請</p>
      </div>
    </div>
    <div className={`step-item is-info ${[ENTRY_STATUS.CODE.SHIPPED].includes(status) ? 'is-active' : ''} ${[ENTRY_STATUS.CODE.REGISTERED, ENTRY_STATUS.CODE.DOWNLOAD_AVAILABLE].includes(status) ? 'is-completed' : ''}`}>
      <div className="step-marker">
        <span className="icon">
          <FontAwesomeIcon icon={faCheck}/>
        </span>
      </div>
      <div className="step-details">
        <p className="step-title is-size-6 is-size-7-mobile">交付情報の登録</p>
      </div>
    </div>
    <div className={`step-item is-info ${[ENTRY_STATUS.CODE.REGISTERED, ENTRY_STATUS.CODE.DOWNLOAD_AVAILABLE].includes(status) ? 'is-active' : ''}`}>
      <div className="step-marker">
        <span className="icon">
          <FontAwesomeIcon icon={faCheck}/>
        </span>
      </div>
      <div className="step-details">
        <p className="step-title is-size-6 is-size-7-mobile">ダウンロード</p>
      </div>
    </div>
  </div>
);

export default Main;
